<template>
  <div>
    <div>官网生成列表:</div>
    <div style="display: flex;justify-content: flex-end;">
      <el-button
        type="primary"
        style="display:flex;border-radius: 10px 10px 0px 0px;"
        @click="jump()"
        >添加</el-button
      >
    </div>
    <el-table :data="tableData" border stripe style="width: 100%">
      <el-table-column label="序号"></el-table-column>
      <el-table-column
        prop="companyId"
        align="center"
        label="编号"
        :width="width"
      >
      </el-table-column>
      <el-table-column
        prop="companyName"
        align="center"
        label="归属公司"
        :width="width * 2"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">
            详情
          </el-button>
          <el-button
            @click="deleteRow(scope.$index, tableData)"
            type="text"
            size="small"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      width: "",
      styleObject: {
        height: ""
      },
      tableData: []
    };
  },
  components: {
    // HelloWorld
  },
  mounted() {
    this.innerHeight();
    this.getList();
  },
  methods: {
    getList() {
      axios
        .get("/api/company/category", {})
        .then(res => {
          if (res.data.success) {
            this.tableData = res.data.data.companyFindDtos;
          }
        })
        .catch(res => {
          console.log(res.data.errorMassage);
        });
    },
    innerHeight() {
      this.width = window.innerWidth / 4;
      this.styleObject.height = window.innerHeight + "px";
      // console.log(this.styleObject.height)
    },
    deleteRow(index, rows) {
      axios
        .get("/api/company/del?companyId=" + rows[index].companyId, {})
        .then(res => {
          if (res.data.success) {
            console.log("success");
          }
        })
        .catch(res => {
          console.log(res.data.errorMassage);
        });
      rows.splice(index, 1);
    },
    handleClick(row) {
      console.log(row.companyid);
      this.$router.push({
        path: "/configuration",
        query: {
          id: row.companyId
        }
      });
    },
    jump() {
      this.$router.push({
        path: "/configuration",
        query: {
          id: 0
        }
      });
    }
  }
};
</script>

<style lang="sass">
.home
  padding: 0 80px 0 80px
  .add
    position: absolute
    right: 7.2%
    .el-button
      border: none
      padding: 5px 5px
      font-size: 16px
  fieldset
    height: 68%
    margin: 0 20px
    legend
      position: relative
      margin-left: 20px
    .div
      text-align: -webkit-center
      padding: 50px 0 0 0
</style>
